import { Stack } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import SelectDungeon from "../../base/SelectDungeon";
import { FlowNodeWithChildren } from "./FlowNode";

interface StartDungeon extends NodeData {
  dungeonId: string;
}

const StartDungeonNode: React.FC<NodeProps<NodeType<StartDungeon>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const dungeonId = nodeData?.dungeonId ?? "";

  const { getValues, setValue, handleSubmit } = useForm<StartDungeon>({
    defaultValues: useMemo(
      () => ({dungeonId}),
      [dungeonId]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<StartDungeon>(nodeId);

  const handleUpdate = useCallback(
    ({ dungeonId }: StartDungeon) => {
      updateNodeData({dungeonId});
    },
    [updateNodeData, setValue]
  );

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <Stack>
          <SelectDungeon color={color} value={getValues("dungeonId")} setValue={(value) => setValue("dungeonId", value)} />
        </Stack>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(StartDungeonNode);
